import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle, XCircle } from 'lucide-react';
import './Dialog.css';

const Dialog = ({
  isOpen,
  onClose,
  type = 'info', // 'success', 'error', 'info'
  title,
  message,
  invoiceId,
  showCloseButton = true,
  showRetryButton = false,
  onRetry
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && showCloseButton) {
      onClose();
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className="dialog-icon success-icon" size={64} />;
      case 'error':
        return <XCircle className="dialog-icon error-icon" size={64} />;
      default:
        return null;
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="dialog-overlay"
          onClick={handleOverlayClick}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <motion.div
            className="dialog-content"
            initial={{ scale: 0.8, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 20 }}
            transition={{ duration: 0.3, type: 'spring', damping: 25 }}
          >
            {showCloseButton && (
              <button
                className="dialog-close-btn"
                onClick={onClose}
                aria-label="Close dialog"
              >
                <X size={24} />
              </button>
            )}

            <div className="dialog-body">
              {getIcon()}

              {title && <h2 className="dialog-title">{title}</h2>}

              {message && <p className="dialog-message">{message}</p>}

              {invoiceId && (
                <div className="invoice-info">
                  <span className="invoice-label">Invoice ID:</span>
                  <span className="invoice-id">{invoiceId}</span>
                </div>
              )}

              <div className="dialog-actions">
                {showRetryButton && onRetry && (
                  <button
                    className="dialog-action-btn retry-btn"
                    onClick={onRetry}
                  >
                    Retry
                  </button>
                )}
                <button
                  className={`dialog-action-btn ${type === 'error' ? 'error-btn' : 'success-btn'}`}
                  onClick={onClose}
                >
                  {type === 'error' ? 'Close' : 'OK'}
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Dialog;
